module.exports = __webpack_public_path__ + "images/emoji/file_folder.a8b571fca84d385435a7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/file_folder.png
// module id = 3FNd
// module chunks = 24